import AppProviders from '@/presentation/contexts/app-providers'
import AppGateway from './app-gateway/app-gateway'
import RouterFactory from './router-factory'
import WhatsAppButton from '@/presentation/components/ui/button/whatsapp-button'

export default function Router() {
  return (
    <AppProviders>
      <AppGateway>
        <RouterFactory />
        <WhatsAppButton />
      </AppGateway>
    </AppProviders>
  )
}
